/* 🤖 this file was generated by svg-to-ts */
export const DfIconDegree16: {
  name: 'degree-16';
  data: string;
} = {
  name: 'degree-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.997 5.51H16V8a1 1 0 0 1-2 0V6.637l-5.624 2.29a1 1 0 0 1-.754 0L.311 5.95a.5.5 0 0 1 .002-.927l7.31-2.951a1 1 0 0 1 .749 0l7.313 2.95a.5.5 0 0 1 .312.488zM13 9.205v2.443a1 1 0 0 1-.445.831C11.036 13.493 9.517 14 8 14c-1.519 0-3.037-.507-4.556-1.522A1 1 0 0 1 3 11.647V9.204l3.868 1.575a3 3 0 0 0 2.262 0z" fill-rule="evenodd"/></svg>`
};
